import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Stack,
    Chip,
    Divider,
    IconButton,
    alpha
} from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

// --- DONNÉES DE TEST (Basées sur ton image) ---
const MOCK_DOSSIERS = [
    { id: 'DOS-2024-001', title: 'Voyage Paris – Marrakech', status: 'Confirmé', client: 'Jean Dupont', prestations: 2, price: '2 592', date: '15/05/2024' },
    { id: 'DOS-2024-015', title: 'Séjour Istanbul – Cappadoce', status: 'Brouillon', client: 'Marie Martin', prestations: 3, price: '1 740', date: '01/06/2024' },
    { id: 'DOS-2024-022', title: 'Circuit Zanzibar – Safari', status: 'Confirmé', client: 'Pierre Bernard', prestations: 3, price: '3 006', date: '01/07/2024' },
    { id: 'DOS-2024-035', title: 'Lune de miel Maldives', status: 'Confirmé', client: 'Luc Petit', prestations: 2, price: '11 460', date: '28/07/2024' },
    { id: 'DOS-2024-041', title: 'Weekend Rome – Vatican', status: 'Annulé', client: 'Claire Roux', prestations: 1, price: '432', date: '25/07/2024' },
];

// --- STYLE DES STATUTS ---
const STATUS_CONFIG = {
    'Confirmé': { color: '#2e7d32', bg: alpha('#2e7d32', 0.1) },
    'Brouillon': { color: '#78909c', bg: alpha('#78909c', 0.1) },
    'Annulé': { color: '#d32f2f', bg: alpha('#d32f2f', 0.1) },
};

export function DossierList() {
    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: alpha('#c9a84c', 0.1),
                bgcolor: "white",
                height: "500px",
                overflowY: "scroll"
            }}
        >
            {/* Header de la liste */}
            <Box sx={{ mb: 4, position: "sticky", top: 0, bgcolor: "white", zIndex: 1 }}>
                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: "'Cormorant Garamond', serif",
                        color: 'secondary.main'
                    }}
                >
                    Dossiers de Voyage
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    {MOCK_DOSSIERS.length} dossiers au total
                </Typography>
            </Box>

            <Stack divider={<Divider sx={{ borderColor: alpha('#000', 0.04) }} />}>
                {MOCK_DOSSIERS.map((dossier) => (
                    <Box
                        key={dossier.id}
                        sx={{
                            py: 3,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            transition: 'all 0.2s',
                            cursor: 'pointer',
                            '&:hover': {
                                bgcolor: alpha('#c9a84c', 0.03),
                                transform: 'translateX(4px)'
                            }
                        }}
                    >
                        {/* Section Gauche : Infos */}
                        <Stack spacing={0.5}>
                            <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 0.5 }}>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: 'primary.main',
                                        fontWeight: 700,
                                        letterSpacing: 0.5
                                    }}
                                >
                                    {dossier.id}
                                </Typography>
                                <Chip
                                    label={dossier.status}
                                    size="small"
                                    sx={{
                                        height: 20,
                                        fontSize: '0.65rem',
                                        fontWeight: 600,
                                        bgcolor: STATUS_CONFIG[dossier.status].bg,
                                        color: STATUS_CONFIG[dossier.status].color,
                                        borderRadius: '6px'
                                    }}
                                />
                            </Stack>

                            <Typography variant="body1" sx={{ fontWeight: 700, color: 'secondary.main', fontSize: '1.1rem' }}>
                                {dossier.title}
                            </Typography>

                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.85rem' }}>
                                {dossier.client} • {dossier.prestations} prestation(s)
                            </Typography>
                        </Stack>

                        {/* Section Droite : Prix & Date */}
                        <Stack direction="row" spacing={3} alignItems="center">
                            <Box sx={{ textAlign: 'right' }}>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        fontWeight: 700,
                                        color: 'secondary.main',
                                        fontFamily: "'DM Sans', sans-serif"
                                    }}
                                >
                                    {dossier.price} FCFA
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                    {dossier.date}
                                </Typography>
                            </Box>

                            <IconButton size="small" sx={{ color: 'primary.main' }}>
                                <ChevronRight />
                            </IconButton>
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </Paper>
    );
}